import React, { useState } from "react";
import red from "../Images/red.svg";
import blue from "../Images/blue.svg";
import purple from "../Images/purple.svg";
import green from "../Images/green.svg";
import navy from "../Images/Navy.svg";
import yellow from "../Images/yellow.svg";
import defaults from "../Images/Akka.png";
import Futures from "../Images/Future.png"
import { useTranslation } from "react-i18next";

export const ValuesAi = () => {
    const { t, i18n } = useTranslation();
    const [hoveredTitleIndex, setHoveredTitleIndex] = useState(0);

    const isRTL = i18n.language === 'ar';

    const titles = [
    { logo: blue, title: t("valueAi.services.1.title"), Descriptions: t("valueAi.services.1.description") },
    { logo: green, title: t("valueAi.services.2.title"), Descriptions: t("valueAi.services.2.description") },
    { logo: yellow, title: t("valueAi.services.3.title"), Descriptions: t("valueAi.services.3.description") },
    { logo: red, title: t("valueAi.services.4.title"), Descriptions: t("valueAi.services.4.description") },
    { logo: navy, title: t("valueAi.services.5.title"), Descriptions: t("valueAi.services.5.description") },
    { logo: purple, title: t("valueAi.services.6.title"), Descriptions: t("valueAi.services.6.description") },
  ];

    return (
        <div className="mt-10 font-sans mb-5" id="Values" dir={isRTL ? 'rtl' : 'ltr'}>
            <p className="flex justify-center text-4xl font-sans sm:text-4xl lg:text-5xl text-[#EF3B3B] font-semibold text-start wow fadeInUp mt-6"></p>
            <div className="lg:mx-24">
                <div className="lg:text-5xl font-geo text-3xl font-bold text-center wow fadeInUp text-[#EF3B3B] mt-6 mb-5">
                    {t("valueAi.services.0.valueText")}
                </div>
            </div>
            <div className="" style={{ backgroundImage: `url(${Futures})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className="p-10 flex mx-20">
                    <div className={isRTL ? 'order-2' : 'order-1'}>
                        <img src={defaults} alt="" className="" />
                    </div>
                    <div className={`flex items-start justify-between w-full ${isRTL ? 'order-1' : 'order-2'}`}>
                        <div className={`${isRTL ? 'order-2' : 'order-1'}`}>
                            {titles.map((text, index) => (
                                <div
                                    key={index}
                                    className={`flex gap-4 mt-4 ${isRTL ? '-mr-5' : '-ml-5'}`}
                                    onMouseEnter={() => setHoveredTitleIndex(index)}
                                    onMouseLeave={() => setHoveredTitleIndex(0)}
                                >
                                    <div className={`bg-gray-200 hover:bg-[#EF3B3B] text-black hover:text-white p-2 gap-2 w-full flex items-center mt-2 ${isRTL
                                            ? 'rounded-r-none pl-6 rounded-l-full'
                                            : 'rounded-l-none pr-6 rounded-r-full'
                                        }`}>
                                        <div>
                                            <img src={text.logo} alt="" className="lg:h-8 sm:h-14 h-24" />
                                        </div>
                                        <div>
                                            <div className={`text-xl font-geo font-semibold ${isRTL ? 'text-right' : 'text-left'}`}>
                                                {text.title}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className={`flex-1 flex items-center p-4 lg:mt-36 mt-1 ${isRTL ? 'mr-10 order-1' : 'ml-10 order-2'
                            }`}>
                            {hoveredTitleIndex !== null && (
                                <div className="w-full">
                                    <div className={`text-4xl font-geo font-black mb-5 text-[#EF3B3B] ${isRTL ? 'text-right' : 'text-left'}`}
                                        style={{ textAlign: isRTL ? 'right' : 'left' }}>
                                        {titles[hoveredTitleIndex].title}
                                    </div>
                                    <div
                                        className={`text-white font-geo text-xl ${isRTL ? 'text-right' : 'text-left'
                                            }`}
                                        style={{ textAlign: isRTL ? 'right' : 'left' }}
                                    >
                                        {titles[hoveredTitleIndex].Descriptions}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};